<style lang="scss" scoped>
.resetPwdWrapper {
  margin-top: 30px;
  box-sizing: border-box;
  padding: 0 60px;
  background-color: #fff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 1200px;
  height: 828px;
}
.noticeTop {
  color: #ff8a00;
  font-size: 20px;
}
.el-form {
  margin: 0 auto;
  // width: 500px;

  ::v-deep .el-input {
    input{
      border: none;
    }
    .el-input__inner {
      background-color: #ebf6ff;
       &::-webkit-input-placeholder {
        color: #a5b6c5;
      }
    }
  }
}

::v-deep .el-dialog {
  .el-dialog__header {
    background-color: #264f78;
    span {
      color: white;
    }
    .el-dialog__headerbtn {
      width: 25px;
      height: 25px;
      border-radius: 50%;
      background-color: #fff;
      i {
        color: #264f78;
        font-weight: bold;
        font-size: 24px;
      }
    }
  }
  .el-dialog__footer {
    text-align: center;
    padding: 40px 116px;
    .el-button {
      width: 100%;
      border-radius: 0;
    }
  }
  .el-dialog__body {
    padding: 70px 116px 0;
  }
}
</style>
<template>
  <!-- <div class="resetPwdWrapper">
    <p class="noticeTop">修改密码</p>
    <el-form :model="pwdForm" ref="pwdForm" :rules="pwdRules">
      <el-form-item prop="old_password">
        <el-input
          type="password"
          v-model="pwdForm.old_password"
          placeholder="请输入老密码"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item prop="new_password">
        <el-input
          type="password"
          v-model="pwdForm.new_password"
          placeholder="请输入新密码"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item prop="check_password">
        <el-input
          type="password"
          v-model="pwdForm.check_password"
          placeholder="请再次输入新密码"
          autocomplete="off"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="bottomBtnWrapper">
      <el-button @click="handleConfirm">确认</el-button>
      <el-button @click="handleCancel">取消</el-button>
    </div>
  </div>-->
  <el-dialog
    title="修改密码"
    :visible="dialogVisible"
    @update:visible="handleUpdateVisible"
    width="580px"
    :close-on-click-modal="false"
  >
    <el-form :model="pwdForm" ref="pwdForm" :rules="pwdRules">
      <el-form-item prop="old_password">
        <el-input
          type="password"
          v-model="pwdForm.old_password"
          placeholder="请输入旧密码"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item prop="new_password">
        <el-input
          type="password"
          v-model="pwdForm.new_password"
          placeholder="请输入新密码"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item prop="check_password">
        <el-input
          type="password"
          v-model="pwdForm.check_password"
          placeholder="请再次输入新密码"
          autocomplete="off"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <!-- <el-button @click="handleCancel">取 消</el-button> -->
      <el-button type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { patchEditPwd } from '@/services/getData';

export default {
  data() {
    const validatePass = (rule, value, callback) => {
      if (this.pwdForm.old_password === '') {
        callback(new Error('请输入旧密码'));
      } else {
        if (this.pwdForm.old_password !== '') {
          this.$refs.pwdForm.validateField('new_password');
        }
        callback();
      }
    };
    const validateNPass = (rule, value, callback) => {
      if (this.pwdForm.new_password === '') {
        callback(new Error('请输入新密码'));
      } else {
        if (this.pwdForm.new_password !== '') {
          this.$refs.pwdForm.validateField('check_password');
        }
        callback();
      }
    };
    const validateCPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入新密码'));
      } else if (value !== this.pwdForm.new_password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      activeIndex: parseInt(this.$route.params.step, 10),
      pwdForm: {
        old_password: '',
        new_password: '',
        check_password: '',
      },
      pwdRules: {
        old_password: [
          {
            validator: validatePass,
          },
        ],
        new_password: [
          {
            validator: validateNPass,
          },
        ],
        check_password: [
          {
            validator: validateCPass,
          },
        ],
      },
    };
  },
  methods: {
    handleNextStep() {
      this.$router.push(
        `/user/forgetpassword/${parseInt(this.$route.params.step, 10) + 1}`,
      );
    },
    handlePrevStep() {
      this.$router.push(
        `/user/forgetpassword/${parseInt(this.$route.params.step, 10) - 1}`,
      );
    },
    handleConfirm() {
      this.$refs.pwdForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          patchEditPwd({
            old_password: this.pwdForm.old_password,
            new_password: this.pwdForm.new_password,
          })
            .then((resp) => {
              // this.$message.success('修改密码成功');
              this.$emit('update:dialogVisible', false);
              // localStorage.clear();
              localStorage.removeItem('authority');
              localStorage.removeItem('currentUser');
              // this.$confirm('修改密码成功，请重新登录。')
              //   .then(() => {
              //     window.location = '/login';
              //   })
              //   .catch((err) => {
              //     console.log(err, 'do nothing');
              //   });
              this.$alert('恭喜您修改密码成功，请重新登录', '修改密码成功', {
                confirmButtonText: '确定',
                showClose: false,
                callback: (action) => {
                  window.location = '/login';
                },
              });
              this.loading = false;
            })
            .catch((err) => {
              this.loading = false;
            });
        }
      });
    },
    handleCancel() {
      // this.$router.go(-1);
      this.$emit('update:dialogVisible', false);
    },
    handleUpdateVisible(e) {
      //点击esc和右上角的x会在dialog里emit update:visible事件
      console.log('继续向外传递');
      this.$emit('update:dialogVisible', e);
    },
  },
  components: {},
  created() {},
  mounted() {},
  props: {
    dialogVisible: {
      type: Boolean,
    },
  },
  watch: {
    dialogVisible(val) {
      if (!val) {
        this.$refs.pwdForm.resetFields();
      }
    },
  },
};
</script>
